module.exports = __webpack_public_path__ + "0ccbe4b2c831995a651936f808014af7.png";